var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-bar-container" },
    [
      _c(
        "div",
        {
          staticClass: "logo",
          class: _vm.collapse ? "menu-bar-collapse-width" : "menu-bar-width",
          style: { "background-color": _vm.themeColor },
          on: {
            click: function($event) {
              return _vm.$router.push("/")
            }
          }
        },
        [
          _vm.collapse ? _c("img", { attrs: { src: _vm.logo } }) : _vm._e(),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.collapse ? "" : _vm.appName))])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          ref: "navmenu",
          class: _vm.collapse ? "menu-bar-collapse-width" : "menu-bar-width",
          attrs: {
            "default-active": "1",
            "default-openeds": _vm.openeds,
            collapse: _vm.collapse,
            "collapse-transition": false,
            "unique-opened": true
          },
          on: {
            open: _vm.handleopen,
            close: _vm.handleclose,
            select: _vm.handleselect
          }
        },
        _vm._l(_vm.navTree, function(item) {
          return _c("menu-tree", { key: item.id, attrs: { menu: item } })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aa9a7c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa9a7c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NavBar/NavBar.vue
// module id = null
// module chunks = 